import React, { useState } from 'react';
import { SafeAreaView, StyleSheet, View } from 'react-native';
import TimePicker from '../TimePicker';
import BottomButton from '../BottomButton';
import BaseText from '../BaseText';
import { CommonProperties } from '../../styles';
import { useNavigation, useRoute } from '@react-navigation/core';

const addZero = (textNumber) => (textNumber?.length > 1 ? textNumber : '0' + textNumber);
const getTime = (time) => `${addZero(time.hours > 12 ? time.hours - 12 : time.hours)}:${addZero(time.minutes)} ${time.hours >= 12 ? 'pm' : 'am'}`;

const TimePickerModal = () => {
  const navigation = useNavigation();
  const route = useRoute();
  const { returnScreen, selectedTimes, oneTime, inputName } = route?.params || {};
  const [startTime, setStartTime] = useState(selectedTimes?.startTime);
  const [endTime, setEndTime] = useState(selectedTimes?.endTime);

  const apply = (event) => {
    event.preventDefault();
    if (startTime || endTime) {
      navigation.navigate(returnScreen, {
        selectedTimes: {
          startTime,
          endTime,
          displayName: getTime(startTime) + (endTime ? ' - ' + getTime(endTime) : ''),
          inputName,
        },
      });
    }
  };

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.innerContainer}>
        <BaseText style={styles.title}>{oneTime ? 'Time' : 'Start Time'}</BaseText>
        <TimePicker value={startTime} onChange={(value) => setStartTime(value)} />
        {!oneTime ? (
          <>
            <BaseText style={styles.title}>End Time</BaseText>
            <TimePicker value={endTime} onChange={(value) => setEndTime(value)} />
          </>
        ) : null}
      </View>
      <BottomButton label="Apply" onPress={apply} />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
  },
  innerContainer: {
    flex: 1,
    ...CommonProperties.p4,
  },
  title: {
    ...CommonProperties.h2,
    ...CommonProperties.my3,
  },
});

export default TimePickerModal;
